exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-fujifilm-xt-5-js": () => import("./../../../src/pages/fujifilm-xt-5.js" /* webpackChunkName: "component---src-pages-fujifilm-xt-5-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-rollei-35-b-js": () => import("./../../../src/pages/rollei-35b.js" /* webpackChunkName: "component---src-pages-rollei-35-b-js" */)
}

